import { OSCI0105001Q } from "@/tz/go/egaz/osci/ptl/ctra/exrt/OSCI0105001Q";
import { Route, Routes } from "react-router-dom";
import { OSCI0105002Q } from "../ctra/hscd/OSCI0105002Q";
import { OSCI0105003Q } from "../ctra/vhcl/OSCI0105003Q";
import { OSCI0105004S } from "../ctra/vhcl/OSCI0105004S";
import { OSCI0105005S } from "../ctra/vhcl/OSCI0105005S";
import { OSCI0105006Q } from "../ctra/vhcl/OSCI0105006Q";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 * TODO URL의 'key' 를 실제 ID로 변경 하세요.
 * TODO 위의 한글 주석은 마지막에 전부 삭제하세요.
 */

export const CtraRouter = () => {
    return (
        <Routes>
            {/** ==================== 환율정보관리 ==================== */}
            <Route path="/exrt/osci0105001q" element={<OSCI0105001Q />} />
            <Route path="/hscd/osci0105002q" element={<OSCI0105002Q />} />
            <Route path="/vhcl/osci0105003q" element={<OSCI0105003Q />} />
            <Route path="/vhcl/osci0105004s" element={<OSCI0105004S />} />
            <Route path="/vhcl/osci0105005s/:vhclMkerCd" element={<OSCI0105005S />} />
            <Route path="/vhcl/osci0105006q/:vhclMkerCd" element={<OSCI0105006Q />} />
        </Routes>
    );
};
